import {
  FeatureCollection,
  isFeatureCollection,
} from "@cartographerio/geometry";
import { isNumber } from "@cartographerio/guard";
import { IO } from "@cartographerio/io";
import {
  ApiConfig,
  ApiParams,
  MapLayerId,
  WorkspaceRef,
} from "@cartographerio/types";
import * as fetch from "../../../fetch";
import { contentAs } from "../../../response";
import { formatUrl, UrlParts } from "../../../url";
import { FeatureSearchParamsV1, formatFeatureSearchParamsV1 } from "./common";

const basePath = "/map/feature/v1";

export function search(
  apiParams: ApiParams,
  layerId: MapLayerId,
  params: FeatureSearchParamsV1 = {}
): IO<FeatureCollection> {
  const url: UrlParts = {
    path: `${basePath}/${layerId}`,
    query: formatFeatureSearchParamsV1(params),
  };

  return fetch
    .get({ apiParams, url })
    .chain(contentAs("FeatureCollection", isFeatureCollection));
}

export function count(
  apiParams: ApiParams,
  layerId: MapLayerId,
  params: FeatureSearchParamsV1 = {}
): IO<number> {
  const url: UrlParts = {
    path: `${basePath}/${layerId}/count`,
    query: formatFeatureSearchParamsV1(params),
  };

  return fetch.get({ apiParams, url }).chain(contentAs("number", isNumber));
}

export function tileUrl(
  apiConfig: ApiConfig,
  layerId: MapLayerId,
  workspace?: WorkspaceRef,
  simplify?: boolean
): string {
  return formatUrl(apiConfig.baseUrl, {
    path: `${basePath}/${layerId}/tile/{z}/{x}/{y}`,
    query: { workspace, simplify },
    encodePath: false,
  });
}
